import React, { useEffect, useRef } from "react";
import "./ActionButton.css";

const ActionButton = ({
  onClick,
  icon: Icon,
  title,
  subtitle,
  disabled = false,
  colors = {
    primary: "#11998e",
    secondary: "#0d7377",
    shadow: "rgba(17, 153, 142, 0.4)",
    shadowHover: "rgba(17, 153, 142, 0.6)",
  },
  decorativeIcon = null,
  style = {},
  ...props
}) => {
  const buttonRef = useRef(null);

  // Reset transform when disabled changes
  useEffect(() => {
    if (disabled && buttonRef.current) {
      buttonRef.current.style.transform = "translateY(0)";
      buttonRef.current.style.boxShadow = "0 2px 8px rgba(156, 163, 175, 0.2)";
    }
  }, [disabled]);
  const renderDecorativeIcon = () => {
    if (!decorativeIcon) return null;

    switch (decorativeIcon.type) {
      case "calendar":
        return (
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              opacity: 0.2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div style={{ width: "8px", height: "6px", background: "white", borderRadius: "1px 1px 0 0", marginBottom: "1px" }}></div>
            <div style={{ width: "10px", height: "8px", background: "white", borderRadius: "0 0 1px 1px", position: "relative" }}>
              <div style={{ position: "absolute", top: "2px", left: "2px", width: "1px", height: "1px", background: colors.primary, borderRadius: "50%" }}></div>
              <div style={{ position: "absolute", top: "2px", right: "2px", width: "1px", height: "1px", background: colors.primary, borderRadius: "50%" }}></div>
              <div style={{ position: "absolute", bottom: "2px", left: "2px", width: "1px", height: "1px", background: colors.primary, borderRadius: "50%" }}></div>
              <div style={{ position: "absolute", bottom: "2px", right: "2px", width: "1px", height: "1px", background: colors.primary, borderRadius: "50%" }}></div>
            </div>
          </div>
        );
      case "chart":
        return (
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              opacity: 0.2,
              display: "flex",
              gap: "2px",
              alignItems: "end",
            }}
          >
            <div style={{ width: "2px", height: "6px", background: "white", borderRadius: "1px" }}></div>
            <div style={{ width: "2px", height: "10px", background: "white", borderRadius: "1px" }}></div>
            <div style={{ width: "2px", height: "4px", background: "white", borderRadius: "1px" }}></div>
          </div>
        );
      case "document":
        return (
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              opacity: 0.2,
              width: "12px",
              height: "15px",
              background: "white",
              borderRadius: "2px",
            }}
          >
            <div style={{ width: "8px", height: "1px", background: colors.primary, margin: "3px 2px 1px 2px" }}></div>
            <div style={{ width: "6px", height: "1px", background: colors.primary, margin: "1px 2px" }}></div>
          </div>
        );
      case "upload":
        return (
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              opacity: 0.2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div style={{ width: "0", height: "0", borderLeft: "3px solid transparent", borderRight: "3px solid transparent", borderBottom: "4px solid white", marginBottom: "1px" }}></div>
            <div style={{ width: "8px", height: "2px", background: "white", borderRadius: "1px" }}></div>
          </div>
        );
      case "settings":
        return (
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              opacity: 0.2,
              width: "10px",
              height: "10px",
              background: "white",
              borderRadius: "50%",
            }}
          >
            <div style={{ position: "absolute", top: "3px", left: "3px", width: "4px", height: "4px", background: colors.primary, borderRadius: "50%" }}></div>
          </div>
        );
      case "cancel":
        return (
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              opacity: 0.2,
              width: "12px",
              height: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div style={{ width: "8px", height: "1px", background: "white", transform: "rotate(45deg)", position: "absolute" }}></div>
            <div style={{ width: "8px", height: "1px", background: "white", transform: "rotate(-45deg)", position: "absolute" }}></div>
          </div>
        );
      case "previous":
        return (
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              opacity: 0.2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div style={{ width: "0", height: "0", borderTop: "4px solid transparent", borderBottom: "4px solid transparent", borderRight: "6px solid white" }}></div>
          </div>
        );
      case "next":
        return (
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              opacity: 0.2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div style={{ width: "0", height: "0", borderTop: "4px solid transparent", borderBottom: "4px solid transparent", borderLeft: "6px solid white" }}></div>
          </div>
        );
      case "validate":
        return (
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              opacity: 0.2,
              width: "12px",
              height: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            
            <div style={{ width: "3px", height: "6px", borderRight: "2px solid white", borderBottom: "2px solid white", transform: "rotate(45deg)", marginTop: "-2px" }}></div>
          </div>
        );
      case "calculator":
        return (
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              opacity: 0.2,
              width: "12px",
              height: "15px",
              background: "white",
              borderRadius: "2px",
            }}
          >
            {/* Écran de la calculatrice */}
            <div style={{ width: "10px", height: "3px", background: colors.primary, margin: "1px", borderRadius: "1px" }}></div>
            {/* Boutons de la calculatrice */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "1px", padding: "1px", marginTop: "1px" }}>
              <div style={{ width: "2px", height: "2px", background: colors.primary, borderRadius: "0.5px" }}></div>
              <div style={{ width: "2px", height: "2px", background: colors.primary, borderRadius: "0.5px" }}></div>
              <div style={{ width: "2px", height: "2px", background: colors.primary, borderRadius: "0.5px" }}></div>
              <div style={{ width: "2px", height: "2px", background: colors.primary, borderRadius: "0.5px" }}></div>
              <div style={{ width: "2px", height: "2px", background: colors.primary, borderRadius: "0.5px" }}></div>
              <div style={{ width: "2px", height: "2px", background: colors.primary, borderRadius: "0.5px" }}></div>
            </div>
          </div>
        );
      case "pass":
        return (
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              opacity: 0.2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {/* Symbole PASS - comme un plafond avec des barres */}
            <div style={{ width: "12px", height: "2px", background: "white", borderRadius: "1px", marginBottom: "1px" }}></div>
            <div style={{ width: "2px", height: "6px", background: "white", borderRadius: "1px", marginRight: "4px", alignSelf: "flex-start" }}></div>
            <div style={{ width: "2px", height: "6px", background: "white", borderRadius: "1px", marginTop: "-6px", alignSelf: "center" }}></div>            <div style={{ width: "2px", height: "6px", background: "white", borderRadius: "1px", marginTop: "-6px", alignSelf: "flex-end" }}></div>
          </div>
        );      case "undo":
        return (
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              opacity: 0.2,
              width: "12px",
              height: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Flèche circulaire pour undo */}
            <div
              style={{
                width: "8px",
                height: "8px",
                border: "2px solid white",
                borderRadius: "50%",
                borderTop: "2px solid transparent",
                borderRight: "2px solid transparent",
                position: "relative",
              }}
            >
              {/* Pointe de flèche */}
              <div
                style={{
                  position: "absolute",
                  top: "-1px",
                  left: "-3px",
                  width: "0",
                  height: "0",
                  borderTop: "3px solid transparent",
                  borderBottom: "3px solid transparent",
                  borderRight: "3px solid white",
                }}
              ></div>
            </div>
          </div>
        );      case "simulation":
        return (
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              opacity: 0.2,
              display: "flex",
              flexDirection: "column",
              gap: "2px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
              <div style={{ width: "6px", height: "1px", background: "white" }}></div>
              <div style={{ width: "3px", height: "3px", background: "white", borderRadius: "50%" }}></div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
              <div style={{ width: "4px", height: "1px", background: "white" }}></div>
              <div style={{ width: "3px", height: "3px", background: "white", borderRadius: "50%" }}></div>
            </div>
          </div>
        );
      case "save":
        return (
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "8px",
              opacity: 0.2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {/* Disquette/Icône de sauvegarde */}
            <div style={{ 
              width: "12px", 
              height: "11px", 
              background: "white", 
              borderRadius: "1px",
              position: "relative"
            }}>
              {/* Encoche en haut à droite */}
              <div style={{ 
                position: "absolute", 
                top: "0", 
                right: "0", 
                width: "3px", 
                height: "3px", 
                background: colors.primary 
              }}></div>
              {/* Zone d'écriture centrale */}
              <div style={{ 
                width: "8px", 
                height: "6px", 
                background: colors.primary, 
                margin: "2px auto 0", 
                borderRadius: "0.5px" 
              }}></div>
              {/* Petite fente de la disquette */}
              <div style={{ 
                width: "6px", 
                height: "1px", 
                background: "white", 
                margin: "1px auto", 
                borderRadius: "0.5px" 
              }}></div>
            </div>
          </div>
        );
      default:
        return decorativeIcon.custom || null;
    }
  };
  const handleMouseEnter = () => {
    if (disabled) return;
    if (buttonRef.current) {
      buttonRef.current.style.transform = "translateY(-2px)";
      buttonRef.current.style.boxShadow = `0 6px 20px ${colors.shadowHover}`;
    }
  };

  const handleMouseLeave = () => {
    if (disabled) return;
    if (buttonRef.current) {
      buttonRef.current.style.transform = "translateY(0)";
      buttonRef.current.style.boxShadow = `0 4px 15px ${colors.shadow}`;
    }
  };
  return (
    <button
      ref={buttonRef}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className="action-button"
      style={{
        background: disabled ? "linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)" : `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
        color: "white",
        border: "none",
        borderRadius: "8px",
        padding: "12px 8px",
        fontSize: "10px",
        fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        gap: "8px",
        boxShadow: disabled ? "0 2px 8px rgba(156, 163, 175, 0.2)" : `0 4px 15px ${colors.shadow}`,
        transition: "all 0.3s ease",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        position: "relative",
        overflow: "hidden",
        minHeight: "44px",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        transform: "translateY(0)",
        ...style,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...props}
    >
      {renderDecorativeIcon()}

      <div
        className="action-button-icon"
        style={{
          background: "rgba(255,255,255,0.2)",
          borderRadius: "6px",
          padding: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon style={{ fontSize: "12px", padding: 0 }} />
      </div>

      <div>
        <div
          className="action-button-title"
          style={{
            textAlign: "left",
            fontWeight: "600",
            marginBottom: "2px",
            textTransform: "none",
            fontSize: "12px",
            marginRight: "40px",
          }}
        >
          {title}
        </div>
        <div
          className="action-button-subtitle"
          style={{
            textAlign: "left",
            fontSize: "9px",
            opacity: 0.8,
            fontWeight: "400",
            textTransform: "none",
            letterSpacing: "normal",
          }}
        >
          {subtitle}
        </div>
      </div>
    </button>
  );
};

export default ActionButton;
